module.exports = __webpack_public_path__ + "static/media/sparksJen.2c0ceb39.jpg";